import { BodyM, Description } from '@casavo/base-ui'
import { ReactElement } from 'react'

import { ellipsis } from '@/shared-styles/styles.css'

export const FilterInfo: React.FC<{
  className?: string
  label: string
  value: string | ReactElement
}> = ({ className, label, value }) => (
  <div className={className}>
    <Description color="greyscale400">{label}</Description>

    <BodyM className={ellipsis}>
      <strong>{value}</strong>
    </BodyM>
  </div>
)
